import { createApp, h } from 'vue'
import CoreUIVuePro from '@coreui/vue-pro'
import CIcon from '@coreui/icons-vue'
import DComponents from '~@/Configurations/DComponents'
import DateTime from '~@/Configurations/DateTime'
import { createInertiaApp, Link, router } from '@inertiajs/vue3'
import { createI18n } from 'vue-i18n'
import AppLayout from './App.vue'
import { iconsSet as icons } from './Configurations/icons'
import { route } from 'ziggy-js'
import '@mdi/font/css/materialdesignicons.min.css'
import mitt from 'mitt'
import en from '../lang/en.json'
import de from '../lang/de.json'

/* Application Setup */
require('./bootstrap')

const ZiggyVue = {
    install: (v, options) => v.mixin({
        methods: {
            $route: (name, params, absolute, config = options) => route(name, params, absolute, config)
        }
    })
}

const emitter = mitt()

createInertiaApp({
    title: () => 'dogado SSL Tool',
    resolve: name => {
        const page = require(`./Pages/${name}`).default
        page.layout = page.layout || AppLayout
        return page
    },
    setup ({ el, App, props, plugin }) {
        const i18n = createI18n({
            legacy: true,
            locale: props.initialPage.props.locale ?? 'en',
            fallbackLocale: 'en',
            messages: { en, de }
        })

        const myApp = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(CoreUIVuePro)
            .use(DComponents)
            .use(DateTime)
            .use(i18n)
            .provide('icons', icons)
            .component('CIcon', CIcon)
            .component('Link', Link)

        myApp.config.globalProperties.emitter = emitter

        router.on('navigate', (event) => {
            i18n.global.locale = event.detail.page.props.locale
        })

        myApp.mount(el)
    },

    progress: {
        color: '#fec600',
        showSpinner: true
    }
})
